import React from 'react';
import { cn } from 'shared/lib/cn';

const TONES = {
  neutral: 'bg-surface-high text-ink-muted border-hairline/20',
  brand: 'bg-brand/15 text-brand-strong border-brand/30',
  flash: 'bg-flash/15 text-flash border-flash/30',
  ok: 'bg-ok/15 text-ok border-ok/30',
  danger: 'bg-danger/15 text-danger border-danger/30',
} as const;

export type ChipProps = { tone?: keyof typeof TONES; className?: string; /** Hover text naming what the chip shows. */ title?: string; children: React.ReactNode };

export function Chip({ tone = 'neutral', className, title, children }: ChipProps) {
  return (
    <span title={title} className={cn('inline-flex items-center rounded-[var(--radius-2)] border px-2 py-0.5 font-code text-tiny uppercase tracking-wide', TONES[tone], className)}>
      {children}
    </span>
  );
}
